<!-- components/ResponsiveWrapper.vue -->
<template>
  <div>
    <!-- 桌面端内容 -->
    <div v-if="isDesktop">
      <slot name="desktop" />
    </div>

    <!-- 移动端内容 -->
    <div v-else>
      <slot name="mobile" />
    </div>
  </div>
</template>

<script setup>
import { useResponsive } from '@/composables/useResponsive';

const { isDesktop } = useResponsive();
</script>
